import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

export function LoginPage() {
  const { user, loading, signInWithGoogle } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const from = (location.state as { from?: Location })?.from?.pathname ?? '/leads';

  useEffect(() => {
    if (!loading && user) navigate(from, { replace: true });
  }, [loading, user, from, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-nm-bg px-4 py-12">
      <div className="fp-card w-full max-w-sm">
        <div className="mb-6 flex items-center gap-2">
          <span className="inline-block h-2 w-2 shrink-0 rounded-full bg-nm-accent" aria-hidden />
          <span className="font-display text-lg font-semibold tracking-tight text-nm-ink">Flashpoint</span>
        </div>
        <h1 className="font-display text-2xl font-semibold text-nm-ink">Generate a client preview from a call</h1>
        <p className="mt-2 text-sm leading-relaxed text-nm-muted">
          Internal access only. Sign in with your Google workspace account, then name + industry is enough to ship a live
          link.
        </p>
        <button type="button" onClick={() => void signInWithGoogle()} className="fp-btn fp-btn-primary mt-8 w-full py-3">
          Continue with Google
        </button>
      </div>
    </div>
  );
}
